import React, { useEffect, useState, useRef } from 'react';
import { Card, Typography, Layout, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';
import LoadingProgress from '../LoadingProgress';

const { Text, Title } = Typography;
const { Content } = Layout;

const cardStyle = {
  maxWidth: '1000px',
};

const textContainerStyle = {
  textAlign: 'center',
  marginTop: '16px',
};

const secondaryTextStyle = {
  marginTop: '8px',
  display: 'block',
};

const progressContainerStyle = {
  textAlign: 'center',
  marginTop: '16px',
};

const CaseLoadingCard = ({ isProcessingEntry }) => {
  const { t } = useTranslation();
  const [showProgress, setShowProgress] = useState(false);
  const timerRef = useRef();
  const [startedAt, setStartedAt] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    // Clear any existing timer
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    if (isProcessingEntry) {
      // Use current time as starting point for new processing
      setStartedAt(new Date().toISOString());
      setShowProgress(false);
      
      timerRef.current = setTimeout(() => {
        setShowProgress(true);
      }, 1000);
    } else {
      setShowProgress(false);
      setStartedAt(null);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [isProcessingEntry]);

  return (
    <Content className="page">
      <Card style={cardStyle}>
        <div style={textContainerStyle}>
          <Title level={5}>
            {isProcessingEntry 
              ? t('case_details.fields.updating_note') 
              : t('case_details.fields.loading_case')}
          </Title>
          <Text style={secondaryTextStyle} type="secondary">
            {t('case_details.fields.loading_message')}
          </Text>
        </div>
        <div style={progressContainerStyle}>
          {showProgress ? (
            <div data-testid="case-loading-progress">
              <LoadingProgress durationSeconds={60} startedAt={startedAt} />
            </div>
          ) : (
            <div data-testid="case-loading-skeleton">
              <Skeleton
                active
                paragraph={{ rows: 4 }}
              />
            </div>
          )}
        </div>
      </Card>
    </Content>
  );
};

export default CaseLoadingCard;
